/**
 * The sign-up metadata sent to supabase.auth.signUp — the ONLY place the
 * person-name / organization-name rule lives.
 *
 * Why this exists: until 2026-09 the org variant of the sign-up form had one
 * field, labelled "Organization Name", prefilled with the org, and sent its
 * value as BOTH full_name and organization_name. handle_new_user copies
 * full_name into profiles, so 25 of 36 production org admins ended up with a
 * profile named after their brokerage. full_name is now always the person.
 *
 * organization_name is sent only for a LEGACY (unbound) org invitation, where
 * /admin/setup reads user_metadata.organization_name to prefill the org it is
 * about to create. A BOUND (pre-activation) invitation's organization already
 * exists, so nothing consumes the value and a copy would go stale on rename.
 */
export type SignupAccountType = "agent" | "organization";

export interface SignupMetadataInput {
  accountType: SignupAccountType;
  fullName: string;
  organizationName: string;
  isBoundInvite: boolean;
}

export interface SignupMetadata {
  full_name: string;
  account_type: SignupAccountType;
  organization_name: string | undefined;
}

export function buildSignupMetadata(input: SignupMetadataInput): SignupMetadata {
  const fullName = input.fullName.trim();
  const organizationName = input.organizationName.trim();
  const sendOrgName = input.accountType === "organization" && !input.isBoundInvite;
  return {
    full_name: fullName,
    account_type: input.accountType,
    organization_name: sendOrgName ? organizationName : undefined,
  };
}
